import { ImageDTO } from '@headless-workspace/domain/common/client';
import { z } from 'zod';
import { HomeSlotBaseDTO } from '../HomeSlotBaseDTO';
import { HomeSlotDTOTypes } from '../HomeSlotDTOTypes';

export type HomeButtonsWebmoDTO = z.infer<typeof HomeButtonsWebmoDTO>;
export const HomeButtonsWebmoDTO = HomeSlotBaseDTO.extend({
    type: HomeSlotDTOTypes.ButtonsWebmo,
    details: z.object({
        items: z.array(
            z.object({
                image: ImageDTO,
                link: z.string().optional(),
                title: z.string().optional(),
            }),
        ),
    }),
});
